import { useAppState } from '../context/LoadTestContext';
import { applyCalibrationRevision, saveCalibrationRevision } from '../services/api';

// Saving a new calibration revision, or putting an existing one in use, for the
// test on screen. Both end any preview and show the numbers the server
// recomputed. Shared by the Calibration window and the preview bar, which can
// each commit what is being previewed.

// What to tell the user after a save: the revision, and any gauges it added to
// the sensor records.
export const savedMessage = (revision) => (
  `Saved as Rev ${revision.rev_number} and now in use`
  + (revision.sensorsAdded?.length ? `. Added to the sensor records: ${revision.sensorsAdded.join(', ')}` : '')
);

export function useCalibrationCommit() {
  const { loadTest, setCalPreview, endCalPreview, applyDashboardData, reloadStrainGaugeOptions, calView } = useAppState();

  const show = (data) => {
    if (data && !data.error) {
      setCalPreview(null);
      applyDashboardData(data);
    } else {
      // The logger is off its box, or the recompute hit a data problem: fall
      // back to whatever the dashboard can load for the box.
      endCalPreview();
    }
  };

  // Resolves to the new revision, with `sensorsAdded`: the strain gauge serials
  // the save added to the sensor records because they weren't on file.
  const save = async (settings, note) => {
    const result = await saveCalibrationRevision(loadTest.id, settings, note, calView);
    show(result.data);
    const sensorsAdded = result.sensors_added || [];
    if (sensorsAdded.length) reloadStrainGaugeOptions();
    return { ...result.revision, sensorsAdded };
  };

  const apply = async (revisionId) => {
    const result = await applyCalibrationRevision(loadTest.id, revisionId, calView);
    show(result.data);
  };

  return { save, apply };
}
